<template>
  <div>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon
        @click.stop="sidebarMenu = !sidebarMenu"
      ></v-app-bar-nav-icon>
      <EventSelect />

      <v-spacer class="pr-5"></v-spacer>
      <CreateEvent />
      <TeamPresence />
      <!--<v-switch
        class="mt-5 mr-5"
        v-model="$vuetify.theme.dark"
        :label="`Go dark`"
      ></v-switch>-->

      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
              @click="actionMenu(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <OnlineUsers
      v-if="$store.state.events.event"
      ref="online"
      :showOnline="showOnline"
    />
    <v-navigation-drawer
      v-if="$store.state.events.event"
      v-model="sidebarMenu"
      app
      floating
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
    >
      <v-list dense color="primary" dark>
        <v-list-item>
          <v-list-item-action>
            <v-icon @click.stop="sidebarMenu = !sidebarMenu"
              >mdi-chevron-left</v-icon
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <img src="@/assets/agmify-logo.png" />
              <!--<h3 class="font-weight-thin">{{ $appTitle }}</h3>-->
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list-item class="px-2" @click="toggleMini = !toggleMini">
        <v-avatar class="mr-2" size="32" color="primary">
          <span class="white--text">{{
            $store.state.manager.firstName.charAt(0) +
              $store.state.manager.lastName.charAt(0)
          }}</span>
        </v-avatar>
        <v-list-item-content class="text-truncate">
          {{
            $store.state.manager.firstName + " " + $store.state.manager.lastName
          }}
        </v-list-item-content>
        <v-btn icon small>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group v-model="group">
          <v-list-item to="/admin/dashboard">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/polls">
            <v-list-item-icon>
              <v-icon>mdi-poll</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Polls</v-list-item-title>
          </v-list-item>
          <v-list-item to="/admin/users">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item>
          <v-list-item to="/admin/reports">
            <v-list-item-icon>
              <v-icon>mdi-file-chart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Reports</v-list-item-title>
          </v-list-item>
          <v-list-item to="/admin/settings">
            <v-list-item-icon>
              <v-icon>mdi-tune-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            to="/admin/global"
            v-if="$store.state.manager.role === 'Administrator'"
          >
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Admin</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import OnlineUsers from "@/components/Widgets/OnlineUsers.vue";
import EventSelect from "@/components/Admin/Header/EventSelect.vue";
import CreateEvent from "@/components/Admin/Header/CreateEvent.vue";
import TeamPresence from "@/components/Admin/Header/TeamPresence/Team.vue";
export default {
  name: "AdminHeader",
  components: {
    OnlineUsers,
    EventSelect,
    CreateEvent,
    TeamPresence
  },
  data: () => ({
    sidebarMenu: true,
    toggleMini: false,
    showOnline: false,
    drawer: true,
    group: "",
    items: [{ title: "Logout" }]
  }),
  computed: {
    mini() {
      return this.$vuetify.breakpoint.smAndDown || this.toggleMini;
    }
  },
  methods: {
    async actionMenu(item) {
      if (item.title === "Logout") {
        await this.$store.dispatch("logout");
        this.$router.push("/admin/login");
      }
    },
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.theme--light.v-application ::-webkit-scrollbar {
  width: 13px;
}

.theme--light.v-application ::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

.theme--light.v-application ::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
  border-radius: 7px;
}

.theme--light.v-application ::-webkit-scrollbar-thumb:hover {
  background: black;
}

.theme--dark.v-application ::-webkit-scrollbar {
  width: 13px;
}

.theme--dark.v-application ::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.theme--dark.v-application ::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.theme--dark.v-application ::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>
